import type { ResourceGetResponse as ResourceOutput } from '@cotera/client/app/etc/api/typed-client';

export type AgentApiData = {
  ownerId: string;
  id: string;
  orgId: string;
  agentKey?: string;
  editorState: unknown;
  model: string;
  locked: boolean;
  createdAt: Date;
  updatedAt: Date;
  title: string | null;
  emoji: string | null;
};

export function toAgentApiData(raw: {
  ownerId: string;
  id: string;
  orgId: string;
  agentKey?: string;
  model: string;
  locked?: boolean;
  title: string | null;
  emoji?: string | null;
  createdAt: Date | string;
  updatedAt: Date | string;
  editorState?: unknown;
}): AgentApiData {
  return {
    ...raw,
    locked: raw.locked ?? false,
    emoji: raw.emoji ?? null,
    editorState: raw.editorState ?? { type: 'doc', content: [] },
    createdAt:
      raw.createdAt instanceof Date ? raw.createdAt : new Date(raw.createdAt),
    updatedAt:
      raw.updatedAt instanceof Date ? raw.updatedAt : new Date(raw.updatedAt),
  };
}

export type AgentResourceApiData = {
  agent: AgentApiData;
  meta: {
    folderId: string | null;
    folderScope?: 'user' | 'org' | 'external' | null;
    permission: 'view' | 'edit' | 'admin';
  } | null;
};

export function toAgentResourceApiData(
  output: ResourceOutput
): AgentResourceApiData | null {
  if (output.type !== 'agent') {
    return null;
  }
  const rawAgent = output.agent;
  if (
    rawAgent === undefined ||
    rawAgent === null ||
    typeof rawAgent !== 'object' ||
    typeof rawAgent.id !== 'string'
  ) {
    return null;
  }
  return {
    agent: toAgentApiData(rawAgent),
    meta: output.meta
      ? {
          folderId: output.meta.folderId,
          folderScope: output.meta.folderScope,
          permission:
            output.meta.permission === 'pending'
              ? 'view'
              : output.meta.permission,
        }
      : null,
  };
}
